/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * a Dashboard
 * @export
 * @interface ApiDashboard
 */
export interface ApiDashboard {
    /**
     * 
     * @type {number}
     * @memberof ApiDashboard
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiDashboard
     */
    dashboardId: number;
    /**
     * 
     * @type {string}
     * @memberof ApiDashboard
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiDashboard
     */
    hidden: boolean;
}

/**
 * Check if a given object implements the ApiDashboard interface.
 */
export function instanceOfApiDashboard(value: object): value is ApiDashboard {
    if (!('dashboardId' in value) || value['dashboardId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('hidden' in value) || value['hidden'] === undefined) return false;
    return true;
}

export function ApiDashboardFromJSON(json: any): ApiDashboard {
    return ApiDashboardFromJSONTyped(json, false);
}

export function ApiDashboardFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiDashboard {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'dashboardId': json['dashboardId'],
        'name': json['name'],
        'hidden': json['hidden'],
    };
}

export function ApiDashboardToJSON(json: any): ApiDashboard {
    return ApiDashboardToJSONTyped(json, false);
}

export function ApiDashboardToJSONTyped(value?: ApiDashboard | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'dashboardId': value['dashboardId'],
        'name': value['name'],
        'hidden': value['hidden'],
    };
}

